import arrayUtils from '@/utils/arrayUtils';

export const sortLoyaltyButtons = ({loyaltyButtonsBar}) => {
    const iconsWithAction = loyaltyButtonsBar?.filter((i) => i?.action);

    if (!iconsWithAction?.length) return null;

    const iconsWithOrder = arrayUtils.sortArrayWithOrderField(iconsWithAction.filter((i) => i?.order !== undefined));
    const iconsWithoutOrder = iconsWithAction.filter((i) => i?.order === undefined);

    return [...iconsWithOrder, ...iconsWithoutOrder].slice(0, 3);
};
